module.exports = __webpack_public_path__ + "img/banner-17.37d4966c.jpg";